<template>
  <b-container>
      <b-row>
          <b-col>
                <b-card class="my-card-style my-5" style="border:none">
                    <!-- <vs-slider ticks step="1000000"  :min="2000000" :max="9000000" v-model="sliders.slider1"/> -->
                    <b-row>
                        <b-col>
                            <h1 class="text-center"> {{ $t('getsalaryinfo') }} </h1>
                        </b-col>
                    </b-row>
                    <b-row class="mt-5">
                        <b-col sm="12" class="d-flex justify-content-between">
                            <span> 6 mln </span>
                            <span> 7 mln </span>
                            <span> 8 mln </span>
                            <span> 9 mln </span>
                            <span> 10 mln </span>
                            <span> 11 mln </span>
                            <span> 12 mln </span>
                            <span> 13 mln </span>
                        </b-col>
                        <b-col sm="12" class="mt-2">
                            <Slider  @input="ChangeSlider" :min="6000000" :max="13000000" :step="1000000" v-model="filter.sum" />
                        </b-col>
                    </b-row>
                    
                    <b-row class="mt-3">
                        <b-col>
                           <h1>  {{ $options.filters.currency(filter.sum, {symbol: '', fractionCount: 2}) }}  </h1>
                        </b-col>
                    </b-row>
                </b-card>
                <h3 class="text-center"> {{ $t('getinfo') }} </h3>
                <b-card class="my-card-style my-4" style="border:none" v-for="(item,index) in SortSalaryInfo" :key="index">
                    <p class="m-0 p-0 font-weight-normal"> <b-badge variant="success"> {{ index+1 }} </b-badge>. {{ $t('sum') }}: <b>  </b> <b-badge  style="font-size:18px" variant="success"> {{ $options.filters.currency(item.sum, {symbol: '', fractionCount: 2}) }} </b-badge> </p>
                    <p class="m-0 p-0 font-weight-normal pl-4" v-if="item.educationinstitution != '-'"> {{ $t('educationinstitution') }} : <b> {{ item.educationinstitution }} </b> </p>
                    <p class="m-0 p-0 font-weight-normal pl-4" v-if="item.basetariff != '-'"> {{ $t('qualificationcategory') }} : <b>  {{ item.basetariff }}  </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.directorfond != '-'"> {{ $t('qualificationpremium') }} : <b> {{ item.directorfond }} %</b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.excellentteacher != '-'"> {{ $t('excellentteacher') }} : <b> {{ item.excellentteacher }} %</b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.classroompremium != '-'"> {{ $t('classroompremium') }} : <b> {{ item.classroompremium }} %</b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.checkingbookspremium != '-'"> {{ $t('checkingbookspremium') }} : <b> {{ item.checkingbookspremium }} %</b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.remoteregions != '-'"> {{ $t('remoteregions') }} : <b> {{ item.remoteregions }} %</b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.foreignlangteacher != '-'"> {{ $t('foreignlangteacher') }} : <b> {{ item.foreignlangteacher }} % </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.fansertifikat != '-'"> {{ $t('fansertifikat') }} : <b> {{ item.fansertifikat }} %</b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.computercabinet != '-'"> {{ $t('computercabinetpremium') }} : <b> {{ item.computercabinet }} %</b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.foreignlangsertificate != '-'"> {{ $t('foreignlangsertificate') }} : <b> {{ item.foreignlangsertificate }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.womanteacherphsical != '-'"> {{ $t('womanpremium') }} : <b> {{ item.womanteacherphsical }} %</b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.renthome != '-'"> {{ $t('renthome') }} : <b> {{ item.renthome }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.olimpiadteacher != '-'"> {{ $t('olimpiadteacher') }} : <b> {{ item.olimpiadteacher }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.olimpiadstudent != '-'"> {{ $t('olimpiadstudent') }} : <b> {{ item.olimpiadstudent }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.ixtisoslikmatematika != '-'"> {{ $t('ixtisoslikmatematika') }} : <b> {{ item.ixtisoslikmatematika }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.C1sertifikat != '-'"> {{ $t('C1sertifikat') }} : <b> {{ item.C1sertifikat }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.B2sertifikat != '-'"> {{ $t('B2sertifikat') }} : <b> {{ item.B2sertifikat }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.redschool != '-'"> {{ $t('redschool') }} : <b> {{ item.redschool }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.specschool != '-'"> {{ $t('specschool') }} : <b> {{ item.specschool }} </b> </p>
                    <p class="m-0 font-weight-normal p-0 pl-4" v-if="item.doctorscience != '-'"> {{ $t('doctorscience') }} : <b> {{ item.doctorscience }} </b> </p>
                </b-card>
          </b-col>
      </b-row>
  </b-container>
</template>

<script>
import Slider from '@vueform/slider/dist/slider.vue2.js'
import SalaryInfo from '../../helper/salaryinfo1.json'
export default {
    components : { Slider },
    data() {
        return {
            filter: {
              sum: 6000000
            },
            SalaryInfo,
            SortSalaryInfo : []
        };
    },
    created(){
        console.log(this.SalaryInfo)
        this.ChangeSlider()
    },
    methods:{
        ChangeSlider(){
            // alert("Sasa")
            if(this.filter.sum === 2000000){
                this.SortSalaryInfo = this.SalaryInfo.filter(item => item.id === 2) 
            }
            if(this.filter.sum === 3000000){
                this.SortSalaryInfo = this.SalaryInfo.filter(item => item.id === 3) 
            }
            if(this.filter.sum === 4000000){
                this.SortSalaryInfo = this.SalaryInfo.filter(item => item.id === 4) 
            }
            if(this.filter.sum === 5000000){
                this.SortSalaryInfo = this.SalaryInfo.filter(item => item.id === 5) 
            }
            if(this.filter.sum === 6000000){
                this.SortSalaryInfo = this.SalaryInfo.filter(item => item.id === 6) 
            }
            if(this.filter.sum === 7000000){
                this.SortSalaryInfo = this.SalaryInfo.filter(item => item.id === 7) 
            }
            if(this.filter.sum === 8000000){
                this.SortSalaryInfo = this.SalaryInfo.filter(item => item.id === 8) 
            }
            if(this.filter.sum === 9000000){
                this.SortSalaryInfo = this.SalaryInfo.filter(item => item.id === 9) 
            }
        }
    }
}
</script>

<style>

.my-card-style{
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
</style>